import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { isExternalOptionsEnum } from './isExternalOptionsEnum';
import { isExternalOptionsField } from './isExternalOptionsField';
import { LinkIcon } from 'foundations-assets';
import { fieldTypeIcons } from '../constants/fieldType';
export const getOverriddenFieldType = (field, getIsUngated, filterFamily) => {
  if (isExternalOptionsEnum(field, getIsUngated) && isExternalOptionsField(field, filterFamily, getIsUngated)) {
    return 'select';
  }
  return field.fieldType;
};
export const getIconComponent = (field, getIsUngated, filterFamily) => {
  const fieldType = getOverriddenFieldType(field, getIsUngated, filterFamily);
  if (field.type === PropertyTypes.STRING && field.textDisplayHint === 'domain_name') {
    return LinkIcon;
  }
  const fieldTypeIcon = fieldTypeIcons[fieldType];
  return fieldTypeIcon;
};